import { Alert } from '@ordo/ui/alert'

import type { ContactSubscriptionsResponse } from '../../hooks/api/useSubscriptionTopics'

export function ContactSmsPreferences({
  smsStoppedAt,
  smsSenderStops,
}: Pick<ContactSubscriptionsResponse, 'smsStoppedAt' | 'smsSenderStops'>) {
  return (
    <section className="space-y-3" aria-label="SMS preferences">
      <h4 className="text-sm font-medium">SMS preferences</h4>
      {smsStoppedAt ? (
        <Alert variant="error">
          <p className="font-medium">Historical SMS STOP applies to all numbers</p>
          <p className="mt-1 text-sm">
            This phone has a retained SMS STOP from {new Date(smsStoppedAt).toLocaleString()}. It blocks SMS from every
            sender, including transactional messages. START to one number and the email/topic controls do not clear this
            record.
          </p>
        </Alert>
      ) : null}
      {smsSenderStops.length ? (
        <div className="space-y-2">
          <p className="text-xs text-muted-foreground">STOP is recorded separately for each physical sender number.</p>
          {smsSenderStops.map((stop) => (
            <div key={stop.senderPhone} className="rounded-md border p-3 text-sm">
              <p className="font-medium">
                {stop.nickname ?? 'Sender number'} · {stop.senderPhone}
              </p>
              <p className="mt-1 text-xs text-muted-foreground">Stopped {new Date(stop.optedOutAt).toLocaleString()}</p>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-xs text-muted-foreground">
          No sender-specific SMS STOP is recorded. Program consent and other delivery preferences still apply.
        </p>
      )}
    </section>
  )
}
